// Youth Art Classes — edit facts, curriculum, and policies here.
export const YOUTH_CLASSES = {
  title: "Youth Art Classes in Denver",
  hero: {
    headline: "You Are An Artist!",
    headlineItalic: "Youth Art Studio",
    sub: "Youth art classes in Denver for ages 8 to 12. Small group drawing, painting, and mixed media, taught by artist and DPS educator Joseph Graves Jr.",
  },
  facts: [
    { k: "Ages", v: "8 to 12" },
    { k: "Schedule", v: "Saturdays, 10 AM – 12 PM" },
    { k: "Location", v: "D'Art Gallery · 900 Santa Fe Drive, Denver" },
    { k: "Class size", v: "Maximum 10 students" },
    { k: "Pilot pricing", v: "$180 for a four-week session" },
    { k: "Materials", v: "All art supplies included" },
  ],
  status: "Interest list open · Dates announced to the list first · Registration not yet open",
  extras: [
    "Sibling discount available — just ask.",
    "A limited number of reduced-tuition spots are available each session. If cost is a barrier, email Joseph directly; no one is turned away for asking.",
    "Two adults in the room for every class.",
  ],
  typicalSaturday: [
    { t: "9:50", v: "Doors open. Sign-in and sketchbook warm-up." },
    { t: "10:00", v: "Short demo — Joseph works through the day's idea on paper." },
    { t: "10:20", v: "Studio time. Students work; Joseph moves table to table." },
    { t: "11:30", v: "Clean-up, then a quick share: each artist says one thing about their piece." },
    { t: "12:00", v: "Pickup. Sign-out at the front desk." },
  ],
  // Registration — flip `open` to true, add the four dates and your Square link, and the register page goes live.
  registration: {
    open: false,
    sessionLabel: "Fall Pilot Session",
    dates: [],
    paymentUrl: "",
    price: 180,
  },
  learn: [
    "Drawing skills and observation",
    "Painting and color mixing",
    "Mixed media and creative storytelling",
    "How professional artists develop an idea into finished artwork",
    "Confidence sharing and talking about their work",
  ],
  weeks: [
    { n: "01", title: "Drawing foundations", body: "Line, shape, observation, and sketchbook practice." },
    { n: "02", title: "Painting, color & composition", body: "Mixing color on purpose and arranging a picture that reads." },
    { n: "03", title: "Mixed media & storytelling", body: "Collage, texture, and telling a story through a piece." },
    { n: "04", title: "Final project & showcase", body: "Finishing a piece and a small student showcase for families." },
  ],
  photos: [
    {
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/ebe1d54e49349d66_IMG_4252.webp",
      alt: "Joseph Graves Jr. in a cowboy hat telling a story to a classroom of young students",
      caption: "Storytelling in a Denver classroom",
    },
    {
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/e16968dd62554b3d_IMG_4232.webp",
      alt: "Joseph Graves Jr. reading a picture book to seated students",
      caption: "Reading to students",
    },
  ],
  why: [
    "Taught by a Denver Public Schools visual arts educator",
    "Professional exhibiting artist — museums, galleries, and public murals",
    "Author of the children's book You Are An Artist!",
    "Small class size so every child gets individual attention",
    "Real materials and artwork to take home",
  ],
  parents: [
    { k: "Sign-in / sign-out", v: "A parent or guardian signs each student in and out at the gallery front desk every week." },
    { k: "Drop-off & pickup", v: "Doors open at 9:50 AM. Please pick up promptly at 12:00 PM; students are released only to the adults listed at registration." },
    { k: "What to bring", v: "A water bottle and clothes that can get messy. Everything else is provided." },
    { k: "Missed classes", v: "Life happens. A missed week can't be refunded, but the student's materials and project are held so they can catch up the following Saturday." },
    { k: "Refunds", v: "Full refund up to 7 days before the first class. After that, a credit toward a future session." },
    { k: "Photos", v: "You'll choose at registration whether your child may appear in class photos used by the studio. No child is photographed without permission." },
  ],
  form: {
    schedules: ["Saturday mornings", "Weekday after school", "Either works"],
    ages: ["8", "9", "10", "11", "12", "Other"],
  },
};
